/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadExternalEhrPatient
 */
export interface PalAuthSubmissionLeadExternalEhrPatient {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    type?: PalAuthSubmissionLeadExternalEhrPatientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    details_push_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    details_extraction_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthSubmissionLeadExternalEhrPatient
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE'
} as const;
export type PalAuthSubmissionLeadExternalEhrPatientTypeEnum = typeof PalAuthSubmissionLeadExternalEhrPatientTypeEnum[keyof typeof PalAuthSubmissionLeadExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLeadExternalEhrPatient interface.
 */
export function instanceOfPalAuthSubmissionLeadExternalEhrPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionLeadExternalEhrPatientFromJSON(json: any): PalAuthSubmissionLeadExternalEhrPatient {
    return PalAuthSubmissionLeadExternalEhrPatientFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadExternalEhrPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'details_push_date': !exists(json, 'details_push_date') ? undefined : json['details_push_date'],
        'details_extraction_date': !exists(json, 'details_extraction_date') ? undefined : json['details_extraction_date'],
        'is_screener_document_upload_in_progress': !exists(json, 'is_screener_document_upload_in_progress') ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': !exists(json, 'is_additional_document_upload_in_progress') ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': !exists(json, 'is_generated_document_upload_in_progress') ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function PalAuthSubmissionLeadExternalEhrPatientToJSON(value?: PalAuthSubmissionLeadExternalEhrPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'type': value.type,
        'details_push_date': value.details_push_date,
        'details_extraction_date': value.details_extraction_date,
        'is_screener_document_upload_in_progress': value.is_screener_document_upload_in_progress,
        'is_additional_document_upload_in_progress': value.is_additional_document_upload_in_progress,
        'is_generated_document_upload_in_progress': value.is_generated_document_upload_in_progress,
    };
}

